// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"176":"styles","348":"component---src-pages-index-tsx","968":"8a128373"}[chunkId] || chunkId) + "-" + {"8":"c6319ef0b0a4a2fcc890","176":"b2c0b53e40f5089b4fe6","348":"38eb109b5aeadb5bbb07","600":"daa78f67ec92f1aea133","968":"ca47b5abfc2875b924e6"}[chunkId] + ".js";
};